import { render } from "./SpecDetail.vue?vue&type=template&id=a481dfac&scoped=true&ts=true"
import script from "./SpecDetail.vue?vue&type=script&lang=ts"
export * from "./SpecDetail.vue?vue&type=script&lang=ts"

import "./SpecDetail.vue?vue&type=style&index=0&id=a481dfac&scoped=true&lang=css"

import exportComponent from "D:\\workspace\\com.xiansheng\\MiezzGitPull\\Miezz\\Miezz.Web.Entry\\client\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a481dfac"]])

export default __exports__